import { configureStore } from "@reduxjs/toolkit";
import GetImageReducer from "./reducers/GetImage/GetImage";
import LoginReducer from "./reducers/Login/Login";

export const store = configureStore({
    reducer:{
       GetImage:GetImageReducer ,
       Login: LoginReducer,
    }
})